/* *
 * ========================================================================
 * Vortex Solution
 * ========================================================================
 * */

// Includes the custom Modernizr build based on the configurations set in .modernizrrc
require('Modernizr'); // eslint-disable-line import/no-extraneous-dependencies
require('nodelist-foreach-polyfill');
require('element-qsa-scope');
require('./main/dropdown-menu');
require('./main/mobile-menu');
require('./main/user-is-tabbing');
require('./main/forms');
require('./main/search-modal');
require('./main/breadcrumbs');
require('./main/buttons');
require('./main/sticky-navbar');
require('./main/alert');
require('./main/anchors-banner');
require('./main/toggle-show-hide');
require('./main/accordion');
require('./main/stats');
require('./main/popup');
require('./main/donnation');
